import * as React from "react";
import { connect } from 'react-redux';
import { navigateTo } from "../../actions/navigationActions";
import { LIFE_PERSONAL_DETAILS, PERSONAL_DETAILS_PERSONAL } from "../../routes/routes";
import { ChooseDetail } from './ChooseDetail';
import { ChooseDetails } from "./ChooseDetails";
import './ChoosePersonalDeets.css';

class ChoosePersonalDeets extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.handleRedirect = this.handleRedirect.bind(this);
    }

    handleRedirect(destination) {
        this.props.redirectTo(destination);
    }
    
     public render() {
        return (
            <>
                <ChooseDetails>
                    <ChooseDetail actionText="View my personal details" link={PERSONAL_DETAILS_PERSONAL} handleClick={this.handleRedirect} title="Personal Policy" />
                    <hr className="choose-payment__break" />
                    <ChooseDetail actionText="View my personal details" link={LIFE_PERSONAL_DETAILS} handleClick={this.handleRedirect} title="Livin' policy" />
                </ChooseDetails>
            </>
        )
     }
}

const mapStateToProps = (state: any) => {
    return {
        router: state.router,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChoosePersonalDeets);